import { Routes } from '@angular/router';
import { AdvertisingDashboardPageComponent } from './pages/advertising-dashboard/advertising-dashboard-page.component';
import { DashboardPageComponent } from './pages/dashboard/dashboard-page.component';
import { ExecutiveReportPageComponent } from './pages/executive-report/executive-report-page.component';
import { ListingsDashboardPageComponent } from './pages/listings-dashboard/listings-dashboard-page.component';
import { ReputationDashboardPageComponent } from './pages/reputation-dashboard/reputation-dashboard-page.component';

export const routes: Routes = [
  { path: 'dashboard', title: 'Conciliação | Mercado Livre', component: DashboardPageComponent },
  { path: 'publicidade', title: 'Publicidade | Mercado Livre', component: AdvertisingDashboardPageComponent },
  { path: 'anuncios', title: 'Anúncios | Mercado Livre', component: ListingsDashboardPageComponent },
  { path: 'relatorios', title: 'Relatórios executivos | Mercado Livre', component: ExecutiveReportPageComponent },
  { path: 'reputacao', title: 'Reputação | Mercado Livre', component: ReputationDashboardPageComponent },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', redirectTo: 'dashboard' }
];
